import { GridColDef } from "@mui/x-data-grid";

const columns: GridColDef[] = [
  {
    field: "id",
    headerName: "Id",
    minWidth: 210,
    flex: 1,
  },
  {
    field: "email",
    headerName: "Email",
    minWidth: 300,
    flex: 1,
  },
  {
    field: "firstName",
    headerName: "First Name",
    minWidth: 210,
    flex: 1,
  },
  {
    field: "lastName",
    headerName: "Last Name",
    minWidth: 210,
    flex: 1,
  },
  {
    field: "displayName",
    headerName: "Client",
    minWidth: 210,
    flex: 1,
  },
];

export default columns;
